module.exports = "<app-interest-form></app-interest-form>\n"


//////////////////
// WEBPACK FOOTER
// /Users/linusvaltersson/AtomizeSource/clean_web/atomize-interest/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main